/* eslint-disable @typescript-eslint/no-unused-vars */
"use client";

import * as X from "@/ui";

import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper/modules";

import "swiper/css";
import "swiper/css/pagination";
import { HowItWorks } from "@/providers/strapi/content/types/components/shipping.component";
import { useShippingPage } from "@/providers/strapi/content/types/singleTypes/shipping-page";
import ReactMarkdown from "react-markdown";

// type Localization<T> = {
//   en: T,
//   fr: T,
//   ko: T,
//   zh: T
// }

type Step = {
  title: string
  bullets: string
}
type ViewModel = {
  steps: Step[],
}

// const defaultData = {
//   steps: [
//     {
//       title: {
//         en: `Shop in Europe`,
//         fr: `Achetez en Europe`,
//         ko: `유럽에서 쇼핑하기`,
//       },
//       bullets:
//       {
//         en: `- Request an invoice with VAT issued to Zapptax (see our billing addresses by country).\nBuy in-store or online — delivery can be arranged by you or by our team.\n- Your goods are stored temporarily in one of our secure warehouses in France, Belgium, Spain, Luxembourg, or the UK.`,
//         fr: `Demandez une facture avec TVA au nom de Zapptax (voir nos adresses de facturation par pays).\n- Commandez en magasin ou en ligne – livraison possible par vous-même ou via nos équipes.\nStockage temporaire sécurisé dans l’un de nos entrepôts en France, Belgique, Espagne, Luxembourg ou Royaume-Uni.`,
//         ko: `- 당사(Zapptax)의 이름 및 주소, 부가가치세(VAT)가 포함 된 인보이스(구매영수증)를 온라인 또는 오프라인 쇼핑 시 요청하세요(국가별 청구지 주소 참조).\n- 온라인 또는 오프라인에서 상품 구매 후, 본인 또는 당사를 통해 물류센터로 배송을 합니다.\n- 고객님의 상품은 프랑스, 벨기에, 스페인, 룩셈부르크 또는 영국에 있는 당사(Zapptax)의 안전한 창고에 임시 보관됩니다.`
//         // ko: `당사(Zapptax)의 이름 및 주소, 부가가치세(VAT)가 포함 된 인보이스(구매영수증)를 온라인 또는 오프라인 쇼핑 시 요청하세요(국가별 청구지 주소 참조).`,
//       },
//       // {
//       //   en: `Buy in-store or online — delivery can be arranged by you or by our team.`,
//       //   fr: `Commandez en magasin ou en ligne – livraison possible par vous-même ou via nos équipes.`,
//       //   ko: `온라인 또는 오프라인에서 상품 구매 후, 본인 또는 당사를 통해 물류센터로 배송을 합니다.`,
//       // },
//       // {
//       //   en: `Your goods are stored temporarily in one of our secure warehouses in France, Belgium, Spain, Luxembourg, or the UK.`,
//       //   fr: `Stockage temporaire sécurisé dans l’un de nos entrepôts en France, Belgique, Espagne, Luxembourg ou Royaume-Uni.`,
//       //   ko: `고객님의 상품은 프랑스, 벨기에, 스페인, 룩셈부르크 또는 영국에 있는 당사(Zapptax)의 안전한 창고에 임시 보관됩니다.`
//       // },
//     },
//     {
//       title: {
//         en: `Ship internationally`,
//         fr: `Expédiez à l’international`,
//         ko: `국제 배송`,
//       },
//       bullets:
//       {
//         en: `- We organize non-EU shipping for you (or you can handle the shipment yourself, subject to conditions).`,
//         fr: `- Nous organisons l’expédition hors UE pour vous (ou vous pouvez gérer l’envoi sous conditions).`,
//         ko: `- 당사에서 EU(유럽국가) 외 지역으로의 배송이 가능합니다.(원하실 경우, 고객님께서 직접 배송을 처리하실 수도 있습니다).`,
//       },

//     },
//     {
//       title: {
//         en: `Get your VAT refund`,
//         fr: `Recevez votre remboursement TVA`,
//         ko: `VAT(세금) 환급 받기`,
//       },
//       bullets:
//       {
//         en: `- Your refund is processed within 5 business days after local tax authorities reimburse the VAT.\n- Benefit from a progressive refund rate: from 60% to 90% of the VAT paid, depending on your order volume.`,
//         fr: `- Remboursement sous 5 jours ouvrables après remboursement de la TVA par l’administration fiscale locale.\n- Profitez d’un taux progressif allant de 60 % à 90 % de la TVA payée, selon votre volume de commandes.`,
//         ko: `- 각 나라의 세관에서 환급 승인을 받은 후 영업일 기준 5일 이내 환급 됩니다.\n- 구매율에 따른 환불 혜택 : 구매 규모에 따라 VAT(세금) 환급율은 60% - 90% 까지 가능합니다.`,
//       },
//       // {
//       //   en: `Benefit from a progressive refund rate: from 60% to 90% of the VAT paid, depending on your order volume.`,
//       //   fr: `Profitez d’un taux progressif allant de 60 % à 90 % de la TVA payée, selon votre volume de commandes.`,
//       //   ko: `구매율에 따른 환불 혜택 : 구매 규모에 따라 VAT(세금) 환급율은 60% - 90% 까지 가능합니다.`,
//       // },

//     },
//   ],
// };

const buildViewModel = (content: HowItWorks): ViewModel => ({
  steps: content.howItWorksItems.map((item, i) => ({
    title: item.title,
    bullets: item.content
  }))
})

export function HowItWorksSection(props: X.PageProps) {
  // const tr = X.useTranslator<"ko">(props);
  const howItWorks = useShippingPage('howItWorks');
  return (
    <section id="how" className={X.clsx(
      "scroll-mt-[120px] relative xl:bg-surface-blue",
      "xl:max-w-content xl:mx-auto pt-6 pb-10 xl:p-12 xl:rounded-4xl",
      "xl:my-20",
    )}>
      {/* <h2 className="relative z-10 mx-mobile-margin xl:mx-0 text-[34px] xl:text-[48px] xl:text-center [&_strong]:font-medium xl:mb-10 leading-tight">
        {tr({
          en: <>How does <strong>it work?</strong></>,
          fr: <>Comment <strong>ça marche{X.Nbsp}?</strong></>,
          ko: <>어떻게 진행되나요?</>,
        })}
      </h2> */}
      <ReactMarkdown components={{
        p: ({ ...props }) => <h2 {...props} className="relative z-10 mx-mobile-margin xl:mx-0 text-[34px] xl:text-[48px] xl:text-center [&_strong]:font-medium xl:mb-10 leading-tight" />
      }}>
        {howItWorks.title}
        {/* {tr({
          en: howItWorks.title,
          fr: howItWorks.title,
          ko: "어떻게 진행되나요?",
          zh: ""
        })} */}
      </ReactMarkdown>

      <Mobile {...props} />
      <Desktop {...props} />

      <div className="flex flex-col items-start xl:items-center mt-4 xl:mt-10 mx-mobile-margin xl:mx-0">
        <X.Button
          primary desktopLg
          className="X-Open-Intercom"
          // label={tr({
          //   en: howItWorks.cta,
          //   fr: howItWorks.cta,
          //   ko: "문의하기",
          //   zh: ""
          // })}
          label={howItWorks.cta}
        // label={tr({
        //   en: "Contact us",
        //   fr: "Contactez-nous",
        //   ko: "문의하기",
        // })}
        />
      </div>
    </section>
  );
}


function Desktop(props: X.PageProps) {
  // const tr = X.useTranslator<"ko">(props);
  const howItWorks = useShippingPage('howItWorks');

  const data = buildViewModel(howItWorks)
  return (
    <div className={X.clsx(
      X.desktopOnly("flex"),
      "rounded-4xl",
      "flex-row items-start gap-8",
    )}>
      {data.steps.map((step, i) => (
        <div key={i} className="bg-white p-8 pb-18 rounded-xl">
          <div className="text-[66px] leading-tight">{i + 1}</div>
          {/* <h3 className="text-[26px] font-semibold mb-4">
            {tr(step.title)}
            {step.title}
          </h3> */}
          <ReactMarkdown components={{
            p: ({ ...props }) => <h3 {...props} className="text-[26px] font-semibold mb-4" />,
            h1: ({ ...props }) => <h3 {...props} className="text-[26px] font-semibold mb-4" />,
            h2: ({ ...props }) => <h3 {...props} className="text-[26px] font-semibold mb-4" />,
            h3: ({ ...props }) => <h3 {...props} className="text-[26px] font-semibold mb-4" />,
            h4: ({ ...props }) => <h3 {...props} className="text-[26px] font-semibold mb-4" />,
          }}>
            {step.title}
          </ReactMarkdown>
          <ReactMarkdown components={{
            ul: ({ ...props }) => <ul {...props} className="text-[20px] list-disc pl-4 mb-4" />,
            li: ({ ...props }) => <li {...props} />
          }}>
            {/* {tr(step.bullets)} */}
            {step.bullets}
          </ReactMarkdown>
          {/* <ul className="text-[20px] list-disc pl-4 mb-4">
            {step.bullets.map((text, i) => (
              <li key={i}>
                {tr(text)}
              </li>
            ))}
          </ul> */}
        </div>
      ))}
    </div>
  );
}


function Mobile(props: X.PageProps) {
  const id = X.useId();
  // const tr = X.useTranslator<"ko">(props);

  const howItWorks = useShippingPage('howItWorks');

  const data = buildViewModel(howItWorks)

  return (
    <div className={X.mobileOnly()}>
      <Swiper
        modules={[Pagination]}
        spaceBetween={16}
        slidesPerView={1.3}
        className="mt-6 relative z-10"
        slidesOffsetBefore={32}
        slidesOffsetAfter={32}
        pagination={{
          el: `#${id}`,
          bulletActiveClass: "w-8 !bg-gray",
          bulletClass: "block w-2 h-2 bg-white rounded-full transition-all duration-300",
          clickable: false,
        }}
      >
        {data.steps.map((step, i) => (
          <SwiperSlide key={i}>
            <div className="bg-white rounded-lg py-6 px-4 flex flex-col gap-4 mb-2">
              <div className="text-[60px] leading-tight">{i + 1}</div>
              {/* <h3 className="text-[20px] font-semibold leading-tight">
                {tr(step.title)}
                {step.title}
              </h3> */}
              <ReactMarkdown components={{
                p: ({ ...props }) => <h3 {...props} className="text-[20px] font-semibold leading-tight" />,
                h1: ({ ...props }) => <h3 {...props} className="text-[20px] font-semibold leading-tight" />,
                h2: ({ ...props }) => <h3 {...props} className="text-[20px] font-semibold leading-tight" />,
                h3: ({ ...props }) => <h3 {...props} className="text-[20px] font-semibold leading-tight" />,
                h4: ({ ...props }) => <h3 {...props} className="text-[20px] font-semibold leading-tight" />,
              }}>
                {step.title}
              </ReactMarkdown>
              <ReactMarkdown components={{
                ul: ({ ...props }) => <ul {...props} className="list-disc pl-4 text-[16px] flex flex-col gap-2" />,
                li: ({ ...props }) => <li {...props} />
              }}>
                {/* {tr(step.bullets)} */}
                {step.bullets}
              </ReactMarkdown>
              {/* <ul className="list-disc pl-4 text-[16px] flex flex-col gap-2">
                {step.bullets.map((text, i) => (
                  <li key={i}>
                    {tr(text)}
                  </li>
                ))}
              </ul> */}
            </div>
          </SwiperSlide>
        ))}

        <div id={id} className="mx-mobile-margin flex flex-row gap-2 mt-4 mb-4" />
      </Swiper>

      <div className="absolute inset-0 right-mobile-margin-half rounded-tr-4xl z-0 bg-surface-blue" />
    </div>
  );
}
